import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const pains = [{
  title: 'Empezás a organizar tarde y el pánico te paraliza',
  desc: 'Las semanas pasan, no sabés por dónde arrancar y el cumpleaños se acerca sin ningún plan concreto.'
}, {
  title: 'Gastás el doble de lo planeado sin entender por qué',
  desc: 'La inflación te come el presupuesto y terminás pidiendo plata prestada para globos y cotillón.'
}, {
  title: 'La decoración queda "casera" cuando querías algo épico',
  desc: 'Comprás de más, mal, en el lugar equivocado y el resultado no te convence a vos ni a nadie.'
}, {
  title: 'Los chicos se aburren y el caos te desborda',
  desc: 'Sin juegos planificados, la fiesta se convierte en una corrida imposible de manejar sola.'
}, {
  title: 'Terminás agotada el día del cumpleaños',
  desc: 'Tan cansada que no podés disfrutar el momento que tanto preparaste durante semanas.'
}, {
  title: 'El año que viene empezás el mismo ciclo desde cero',
  desc: 'Sin sistema, cada cumpleaños es como el primero. Un caos nuevo cada año.'
}];
export function PainPoints() {
  return <section aria-label="Problemas" className="border-y border-white/5 bg-ink-2" data-id="element-106" data-mp="27sqqqiwoyxne">
      <div className="mx-auto max-w-4xl px-5 pt-[5px] pb-[33px]" data-id="element-107" data-mp="27utcuruq46mu">
        <h2 className="text-center font-display text-[28px] font-black text-white sm:text-4xl" data-id="element-108" data-mp="23rx0hivs16rc">
          ¿Cuántos cumpleaños más vas a improvisar así?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-white/70" data-id="element-109" data-mp="1b3hoz6but6kr">
          Querés que tu hijo tenga una fiesta increíble. Pero nadie te dijo que ibas a pasar semanas
          sin dormir, gastando de más y llegando al día del cumple con el corazón en la boca.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-bold text-iris-soft" data-id="element-110" data-mp="30gux76n37er5">
          No es falta de amor. No es falta de ganas. Es falta de un sistema.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-111" data-mp="1t5ohqucye1vq">
          {pains.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08
        }} className="flex gap-3 rounded-xl border border-white/10 bg-ink p-5" data-id="element-112" data-mp="1y3ztjamt6mgl" data-mpi={i}>
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-iris/20 text-iris-soft" data-id="element-113" data-mp="1ackmx5o01izj">
                <XIcon className="h-4 w-4" strokeWidth={3} data-id="element-114" data-mp="1jflqozpe6y01" />
              </span>
              <div data-id="element-115" data-mp="1jdiufxxnc8mv">
                <h3 className="text-sm font-bold text-white" data-id="element-116" data-mp="1o6lnm4yihg2j">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-white/60" data-id="element-117" data-mp="1o7wtcabioxwa">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-118" data-mp="vogbmmra09qs">
          <p className="font-display text-2xl font-bold text-white sm:text-3xl" data-id="element-119" data-mp="vner7rodeawe">
            ¿Y si este fuera el último cumpleaños que organizás sin un sistema probado?
          </p>
          <p className="mt-3 text-lg font-semibold text-iris-soft" data-id="element-120" data-mp="j52jewue348c">
            La próxima semana puede ser diferente.
          </p>
        </div>
      </div>
    </section>;
}